"use strict";

function getOriginalCounterPart(index, _a, childrenArr) {
  var slidesToShow = _a.slidesToShow,
      currentSlide = _a.currentSlide;
  return childrenArr.length > 2 * slidesToShow ? index + 2 * slidesToShow : currentSlide >= childrenArr.length ? childrenArr.length + index : index;
}

function getCloneCounterPart(index, _a, childrenArr) {
  var slidesToShow = _a.slidesToShow;
  return childrenArr.length > 2 * slidesToShow ? 0 === index ? childrenArr.length + 2 * slidesToShow : index - (childrenArr.length - 2 * slidesToShow) : 0 === index ? 2 * childrenArr.length : void 0;
}

function getClones(slidesToShow, childrenArr) {
  var initialSlide, clones, k;
  return k = childrenArr.length > 2 * slidesToShow ? (clones = childrenArr.slice(childrenArr.length - 2 * slidesToShow, childrenArr.length).concat(childrenArr, childrenArr.slice(0, 2 * slidesToShow)), initialSlide = 2 * slidesToShow, 2) : (clones = childrenArr.concat(childrenArr, childrenArr), initialSlide = childrenArr.length, childrenArr.length), {
    clones: clones,
    initialSlide: initialSlide,
    k: k
  };
}

function checkClonesPosition(_a, childrenArr, props) {
  var isReachingTheEnd,
      currentSlide = _a.currentSlide,
      slidesToShow = _a.slidesToShow,
      itemWidth = _a.itemWidth,
      totalItems = _a.totalItems,
      nextSlide = 0,
      nextPosition = 0,
      isReachingTheStart = 0 === currentSlide,
      originalFirstSlide = childrenArr.length - (childrenArr.length - 2 * slidesToShow);
  return childrenArr.length > 2 * slidesToShow ? ((isReachingTheEnd = currentSlide >= originalFirstSlide + childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = -itemWidth * (nextSlide = originalFirstSlide + (childrenArr.length - 2 * slidesToShow)))) : ((isReachingTheEnd = currentSlide >= 2 * childrenArr.length) && (nextPosition = -itemWidth * (nextSlide = currentSlide - childrenArr.length)), isReachingTheStart && (nextPosition = props.showDots ? -itemWidth * (nextSlide = childrenArr.length) : -itemWidth * (nextSlide = totalItems - 2 * slidesToShow))), {
    isReachingTheEnd: isReachingTheEnd,
    isReachingTheStart: isReachingTheStart,
    nextSlide: nextSlide,
    nextPosition: nextPosition
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.getOriginalCounterPart = getOriginalCounterPart, exports.getCloneCounterPart = getCloneCounterPart, exports.getClones = getClones, exports.checkClonesPosition = checkClonesPosition;